/* eslint-disable max-len */

import cls from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import MessageContainer from '@/components/message/items/message-container';
import MessageAvatar from '@/components/message/items/message-avatar';
import styles from './style.module.scss';
import PlayIcon from './play-icon.svg';

/**
 * @typedef IVideoMessageProps
 * @property {boolean} fromMe 是否是当前用户发的
 * @property {string} url 视频 URL
 * @property {string} senderName 发送者名称
 * @property {string} avatar 发送者头像
 * @property {string} avatarClassName 发送者头像样式
 */

/**
 * @param {IVideoMessageProps} props
 * @return {JSX.Element}
 */
function VideoMessage(props) {
  const { avatar, fromMe, avatarClassName, url, senderOid, senderType } = props;

  const parsedURL = useMemo(() => {
    if (!url || (typeof url === 'string' && url.includes('#'))) {
      return url;
    }
    /**
     * Safari 无法通过 video 标签显示视频的第一帧, 所以使用 #t=0.001 去加载第一帧
     * @see https://stackoverflow.com/questions/41255841/how-to-get-html5-video-thumbnail-without-using-poster-on-safari-or-ios
     */
    return `${url}#t=0.001`;
  }, [url]);

  return (
    <MessageContainer fromMe={fromMe}>
      <MessageAvatar
        className={avatarClassName}
        fromMe={fromMe}
        avatar={avatar}
        senderOid={senderOid}
        senderType={senderType}
      />
      <div
        className={cls('ms-content', { right: fromMe, left: !fromMe }, styles.videoContent)}
      >
        <div className={styles.videoWrapper}>
          <video className={styles.video} src={parsedURL} autoPlay={false} controls={false} preload="metadata" />
          <div className={styles.videoMask} data-video-preview-url={url}>
            <img className={styles.playIcon} src={PlayIcon} alt="播放" data-no-preview="true" />
          </div>
        </div>
      </div>
    </MessageContainer>
  );
}

VideoMessage.propTypes = {
  avatar: PropTypes.string,
  fromMe: PropTypes.bool,
  url: PropTypes.string,
  senderType: PropTypes.string,
  senderOid: PropTypes.string,
  avatarClassName: PropTypes.string,
};

export default VideoMessage;
